import {
    FETCH_CAMPAIGN_GROUPS_LIST_ERROR,
    FETCH_CAMPAIGN_GROUPS_LIST_SUCCESS,
    REQUEST_FETCH_CAMPAIGN_GROUPS_LIST,
} from './actionTypes';

export const requestFetchCampaignGroupsList = () => ({ type: REQUEST_FETCH_CAMPAIGN_GROUPS_LIST });
export const fetchCampaignGroupsListSuccess = payload => ({
    type: FETCH_CAMPAIGN_GROUPS_LIST_SUCCESS,
    payload,
});
export const fetchCampaignGroupsListError = error => ({ type: FETCH_CAMPAIGN_GROUPS_LIST_ERROR, payload: error });
